import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { Image } from "./Photo.styles";

const Photo = ({ url, alt, clickable, ...props }) => {
    const onImageError = (event) => {
        event.target.src = "/assets/images/default-profile.svg";
    };

    return (
        <Suspense
            fallback={
                <Image
                    src={"/assets/images/default-profile.svg"}
                    clickable={clickable}
                />
            }
        >
            <Image
                key={url}
                src={url}
                alt={alt}
                clickable={clickable}
                onError={(event) => onImageError(event)}
                className={props.className}
            />
        </Suspense>
    );
};

Photo.defaultProps = {
    url: "/assets/images/default-profile.svg",
    alt: "",
    clickable: false,
};

Photo.propTypes = {
    url: PropTypes.string,
    alt: PropTypes.string,
    clickable: PropTypes.bool,
    className: PropTypes.string,
};

export default Photo;
